export default theme => {
    return {}
}



// WEBPACK FOOTER //
// ./src/app/configuration/HEB/theme/components/scorecard/MetricsLabels/index.js